export const navItems = [
  { label: "À propos", href: "#cabinet" },
  { label: "Vos besoins", href: "#besoins" },
  { label: "Nos produits", href: "#placements" },
  { label: "Professionnels", href: "#professionnels" },
  { label: "Actualités", href: "#actualites" },
  { label: "Contact", href: "#contact" },
];
